// 计时悬浮球
import circleTask from './circleTask.vue';
// 点击悬浮球
import contentTask from './contentTask.vue';
export default {
  name: 'suspension',
  components: {
    circleTask,
    contentTask
  },
  data() {
    return {
      showTask: true
    };
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    isDark: {
      type: Boolean,
      default: false
    },
    tpSource: {
      type: String,
      default: ''
    },
    stdTag: {
      type: String,
      default: ''
    }
  },
  computed: {},
  methods: {
    goBdLogin(value = '') {
      this.$emit('clickTask', value);
    },
    onShowTask(value = '') {
      this.showTask = value;
    }
  }
};